// Utils
import sortLiabilitiesByKey from 'shared/utils/walletOverview/sortByKey';

function selectLiabilitiesDataFromWalletOverview(
	walletOverviewData,
	filterByTradeLineType
) {
	if (!walletOverviewData)
		return { liabilities: [], clientFinancialData: {} };

	const { liability } = walletOverviewData;
	const { liabilities } = liability;

	const filteredLiabilities = liabilities.filter((cLiability) =>
		filterByTradeLineType.includes(cLiability.tradeLineType)
	);

	const sortedLiabilitiesByTradelineType = sortLiabilitiesByKey(
		filteredLiabilities,
		'tradeLineType'
	);

	return sortedLiabilitiesByTradelineType;
}

export default selectLiabilitiesDataFromWalletOverview;
